











import useInjectStylesPublishVdr from '../../hooks/publish/injectStylesPublishVdr.hook';
import { defineComponent } from '@vue/composition-api';
import { MetaInfo } from 'vue-meta';
import { formatLocalUrl, LinkType } from '../../constants/link';

export default defineComponent({
  name: 'RectangleElementPublish',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  metaInfo(): MetaInfo {
    return {
      style: [{ type: 'text/css', cssText: this.stylesToHead }],
      __dangerouslyDisableSanitizers: ['style']
    };
  },
  setup(props, { root }) {
    const stylesToHead = useInjectStylesPublishVdr(props.value);

    const hrefValue = formatLocalUrl(root.$store.state, props.value.payload.link);

    return {
      LinkType,
      stylesToHead,
      hrefValue,
      element: props.value
    };
  }
});
